export default "__VITE_ASSET__BZvKwYD7__"